import getEnvironDomain from 'ati-utils/getEnvironDomain';

import { alert } from 'as-ui-kit/utils/statusMessage';
import { pascalToCamelCaseObj } from 'as-ui-kit/utils/adapters';
import { getCookies } from 'as-ui-kit/utils/cookies';
import { getLocaleFromCookies } from 'as-ui-kit/utils/locale';
import { strings as i18nStrings } from 'as-ui-kit/strings';

export const getAuthHeader = () => ({});

export const getFetchOptions = (body = null, method = 'GET', setContentType = false, corsHeadersSensitive = false) => {
    const headers = {
        Accept: 'application/json',
    };

    const branchCookie = getCookies()['lf_branch'];
    if (branchCookie && !corsHeadersSensitive) {
        headers['X-Branch'] = branchCookie;
    }

    if (body != null || setContentType) {
        headers['Content-Type'] = 'application/json';
    }

    return {
        headers,
        credentials: 'include',
        method,
        ...(body != null ? { body: JSON.stringify(body) } : {}),
    };
};

export const handleResult = (response, idUrl = null) => {
    response = handleUnauthorized(response, idUrl);
    const hasErrorStatus = parseInt(response.status, 10) >= 400;

    const contentType = response.headers.get('Content-Type');
    if (contentType && contentType.search('application/json') >= 0) {
        return response.json().then(result => {
            if (hasErrorStatus) {
                throw result;
            }
            return result;
        });
    }

    if (hasErrorStatus) {
        throw response;
    }
    return response;
};

export const handleXHRResult = (response) => {
    response = handleUnauthorized(response);
    const hasErrorStatus = parseInt(response.status, 10) >= 400;

    if (hasErrorStatus) {
        throw response;
    }

    return response;
};

export const handleResultWithInjectedFields = withInjectedFields(handleResult);

export const handleUnauthorized = response => {
    const status = parseInt(response.status, 10);
    if (status === 401) {
        const location = window?.location;
        const mainDomain = getEnvironDomain();

        if (!mainDomain || !location) {
            throw null;
        }

        window.location = `//id.${mainDomain}/login/?next=${encodeURIComponent(location.href)}`;
        throw null;
    }
    return response;
};

export const catchWithAlert = err => {
    const locale = getLocaleFromCookies();
    const strings = i18nStrings[locale];
    const error = pascalToCamelCaseObj(err);

    if (Array.isArray(err)) {
        alert(!!err.length && err.map(e => strings[e.error] || strings['unknown_error']).join('\n'));
    }

    alert(strings[error?.error] || strings[error?.error_code] || strings['unknown_error']);

    throw error;
};

/**
 * @param {Response} response
 */
export const injectDateFromHeader = response => {
    const { headers } = response;
    const serverTime = headers.get('date') || headers.get('Date');
    return {
        response,
        injectedFields: {
            serverTime,
            currentTime: new Date().toISOString(),
        },
    };
};

/**
 * @param {Function} handleResult
 */
function withInjectedFields(handleResult) {
    return async (responseWithInjectedFields, idUrl = null) => {
        const { response, injectedFields } = responseWithInjectedFields;
        const result = await handleResult(response, idUrl);
        return { result, injectedFields };
    };
}
